import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate } from '../../utils';
import { getFullName } from '../Person/utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);
  const rows = [];
  data.forEach(
    ({
      name,
      type,
      propertyName,
      facilityCode,
      firstCardNumber,
      lastCardNumber,
      cardNumberOffset,
      createdAt,
      creator,
    }) => {
      rows.push([
        name,
        type,
        propertyName,
        firstCardNumber,
        lastCardNumber,
        cardNumberOffset,
        facilityCode,
        formatDate(createdAt),
        getFullName(creator),
      ]);
    },
  );
  return { headers, rows };
};

const AccessCardsBatchListExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default AccessCardsBatchListExport;
